import styled from 'styled-components';
import { secondary } from '../../App/theme';

export const Container = styled.div`
  border: 1px solid ${secondary.main};
  box-sizing: border-box;
  border-radius: 25px;
  width: 80%;
  padding: 10px 30px 10px 30px;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  margin-top: 6px;
  word-break: break-word;
`;